module.exports = __webpack_public_path__ + "img/5.7de59f9c.png";